<template>
  <VAutocompleteWithValidation
    v-model="innerValue"
    label="Vyhledat dárek"
    :rules="rules"
    :items="innerItems"
    item-text="name"
    item-value="id"
    :search-input.sync="search"
    :loading="loading"
    :custom-slot="true"
    outlined
    dense
    :clearable="true"
    v-on="$listeners"
  >
    <template slot="item" slot-scope="{ item }">
      <span> {{ item.id }} - {{ item.name }} </span>
    </template>
    <template slot="selection" slot-scope="{ item }">
      <span> {{ item.id }} - {{ item.name }} </span>
    </template>
  </VAutocompleteWithValidation>
</template>

<script>
import { mapActions } from 'vuex'
import VAutocompleteWithValidation from '@/components/validators/VAutocompleteWithValidation'

export default {
  name: 'GiftAutocomplete',
  components: { VAutocompleteWithValidation },
  props: {
    value: {
      type: null,
    },
    rules: {
      type: String,
      require: false,
      default: 'required',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    innerValue: '',
    innerItems: [],
    search: '',
    loading: false,
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal)
    },
    innerItems(newVal) {
      this.$emit('items', newVal)
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal
    },
    items(newVal) {
      this.innerItems = newVal
    },
    search(value) {
      if (typeof this.value == 'number') {
        return
      }
      if (!value || !value.length) {
        this.searchGift(value, true)
      } else {
        this.searchGift(value, false)
      }
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
    if (this.items) {
      this.innerValue = this.items
    }
    this.searchGift('', true)
  },
  methods: {
    ...mapActions({
      searchGifts: 'gift/searchGifts',
    }),
    searchGift(value, initial) {
      if (this.cancel) {
        this.cancel()
        this.cancel = null
      }
      if (!value && !initial) {
        return
      }
      let query = {}
      if (initial) {
        query['size'] = 100
      } else {
        query['searchTerm'] = value
      }
      const searchParams = {
        filterParams: query,
      }
      this.loading = true
      this.searchGifts(searchParams)
        .then((response) => {
          this.innerItems = response.data.items
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
